import { render, staticRenderFns } from "./PatientPhotoAvatar.vue?vue&type=template&id=dd92fe1c&scoped=true"
import script from "./PatientPhotoAvatar.vue?vue&type=script&lang=js"
export * from "./PatientPhotoAvatar.vue?vue&type=script&lang=js"
import style0 from "./PatientPhotoAvatar.vue?vue&type=style&index=0&id=dd92fe1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd92fe1c",
  null
  
)

export default component.exports